import WangEditor from "wangeditor";
import { formulaIcon } from "./icon/svg-icon";
// import mammoth from "mammoth"; // 用于解析 Word 文件
function textNode() {
  const selection = window.getSelection();
  if (selection.rangeCount === 0) return;
  const range = selection.getRangeAt(0);

  const textNode = range.commonAncestorContainer;

  if (textNode.nodeType === 3) {
    const content = textNode.textContent;
    const regex = /\\\((.*?)\\\)/gs; // 匹配 \\(...\\) 内容
    let lastIndex = 0;
    const fragment = document.createDocumentFragment();

    let match;
    let lastMathField = null;

    while ((match = regex.exec(content)) !== null) {
      // 添加公式前的普通文本
      if (match.index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(content.substring(lastIndex, match.index))
        );
      }

      // 创建 math-field 元素
      const mathField = document.createElement("math-field");
      mathField.id = "math-field" + Math.random();
        mathField.style="border: none;"
      mathField.textContent = match[0];
      fragment.appendChild(mathField);
      lastMathField = mathField;

      // 更新最后匹配位置
      lastIndex = regex.lastIndex;
    }

    // 添加剩余文本
    if (lastIndex < content.length) {
      fragment.appendChild(
        document.createTextNode(content.substring(lastIndex))
      );
    }

    // 替换原始文本节点为 span
    const parentNode = textNode.parentNode;
    parentNode.replaceChild(fragment, textNode);

    // 设置光标在最后一个 math-field 后面
    if (lastMathField && selection && range) {
      range.setStartAfter(lastMathField);
      range.collapse(true); // 光标放在 math-field 后
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
}
function createKityformula(editor) {
  // panel 中需要用到的id
  const inputIFrameId = "kityformula_" + Math.ceil(Math.random() * 10);
  const btnOkId = "kityformula-btn" + Math.ceil(Math.random() * 10);
 const fileInputId = "word-file-input" + Math.ceil(Math.random() * 10);
  const conf = {
    width: 900,
    height: 560,

    // panel 中可包含多个 tab
    tabs: [
      {
        // tab 的标题
        title: "插入公式",
        // 模板
        tpl: `<div style="z-index: 99999;" >
                  <iframe  id="${inputIFrameId}" class="iframe" height="500px" width="100%" frameborder="0" scrolling="no" src="/kityformula/index.html"></iframe>

                  <div class="w-e-button-container">
                      <button id="${btnOkId}" class="right">
                            确认插入
                      </button>
                  </div>
              </div>`,
        // 事件绑定
        events: [
          {
            selector: "#" + btnOkId,
            type: "click",
            fn: () => {
              // 执行插入公式
              const node = document.getElementById(inputIFrameId);
              const kfe = node.contentWindow.kfe;
              let latex = kfe.execCommand("get.source");
              latex = latex.replace(/\s/g, ""); // 去掉空格
              sessionStorage.setItem("insertHTML", true);
              editor.cmd.do("insertHTML", `\\(${latex}\\)&nbsp;`);
              textNode();
              return true;
            }
          }
        ]
      },
      //   {
      //   // tab 的标题
      //   title: "导入试卷",
      //   // 模板
      //   tpl: ` 
      //   <div  style='width:100%;height:100%;'>
      //    <input style="display: none;" type="file" id="${fileInputId}" accept=".docx"> </input> 
      //     <button style='margin: auto;' id="${btnOkId}">导入试卷</button>
      //  </div>`,
      //   // 事件绑定
      //   events: [
      //     {
      //       selector: "#" + btnOkId,
      //       type: "click",
      //       fn: e => {
      //         // 点击自定义按钮时触发文件选择对话框
      //         document.getElementById(fileInputId).click();
      //         return true;
      //       }
      //     },
      //     {
      //       selector: "#" + fileInputId,
      //       type: "change",
      //       fn: e => {
      //         console.log("上传文件被点击");
      //         const file = e.target.files[0];
      //         if (file) {
      //           parseAndInsertWord(editor, file);
      //         }
      //         return true;
      //       }
      //     }
      //   ]
      // }
    ] 
  };

  return conf;
}
//解析字符串创建虚拟dome
function createVirtualDOM(str) {
  const results = [];
  const combinedPattern = /(\\begin\{.*?\}.*?\\end\{.*?\}|\\\[[^]*?\\\]|\\\([^]*?\\\)|\$[^]*?\$|\\\w+|\\[^\s\\{}]+|<img\s[^>]*>)/gs;

  // 生成本次函数调用的唯一标识（避免不同调用间ID冲突）
  const callUUID = `dom_${Date.now().toString(36)}_${Math.random()
    .toString(36)
    .slice(2, 6)}`;

  // 分割字符串并过滤空值
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = combinedPattern.exec(str)) !== null) {
    if (match.index > lastIndex) {
      parts.push(str.substring(lastIndex, match.index));
    }
    parts.push(match[0]);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < str.length) parts.push(str.substring(lastIndex));

  // 处理每个分段
  parts.filter(Boolean).forEach((element, index) => {
    const isLatex = /^\\/.test(element) || /^\$/.test(element);
    const isImage = /^<img/i.test(element);

    // 添加唯一ID到图片标签
    if (isImage) {
      const imgId = `${callUUID}_img${index}`;
      const parser = new DOMParser();
      const doc = parser.parseFromString(element, "text/html");
      const img = doc.querySelector("img");

      if (img) {
        img.id = imgId;
        element = img.outerHTML; // 更新为带ID的标签
      }
    }

    results.push({
      type: isLatex ? "latex" : isImage ? "image" : "text",
      value: element,
      // 为图片元素附加ID元数据
      ...(isImage && { metadata: { id: `${callUUID}_img${index}` } })
    });
  });

  // 构建HTML输出
  return results.reduce((html, item, idx) => {
    switch (item.type) {
      case "latex":
        return (
          html +
          `<math-field id="math-field${idx}" style="border: none;">${item.value}</math-field>`
        );
      default:
        return html + item.value;
    }
  }, "");
}
// // 解析 Word 文件并插入到编辑器
// async function parseAndInsertWord(editor, file) {
//   try {
//     const reader = new FileReader();
//     const resultPromise = new Promise((resolve, reject) => {
//       reader.onload = e => {
//         const arrayBuffer = e.target.result;
//         mammoth
//           .convertToHtml({ arrayBuffer }, { includeEmbeddedStyleMap: true })
//           .then(result => resolve(result.value))
//           .catch(error => reject(error));
//       };
//       reader.onerror = () => reject(new Error("文件读取失败"));
//       reader.readAsArrayBuffer(file);
//     });

//     const htmlContent = await resultPromise;
//     if (editor) {
//       editor.txt.append(createVirtualDOM(htmlContent)); // 使用 append 方法将内容添加到编辑器当前位置
//     } else {
//       console.error("editor  未定义");
//     }
//   } catch (error) {
//     console.error("  文档转换出错:", error);
//   }
// }
const { PanelMenu, Panel } = WangEditor;
export default class Kityformula extends PanelMenu {
  // 公式输入插件
  constructor(editors) {
    const $elem = WangEditor.$(
      `<div class="w-e-menu" >
              ${formulaIcon}
          </div>`
    );

    super($elem, editors);
  }
  // 菜单点击事件
  clickHandler() {
    // 做任何你想做的事情
    // 可参考【常用 API】文档，来操作编辑器
    const conf = createKityformula(this.editor);
    const panel = new Panel(this, conf);
    panel.create();
  }

  tryChangeActive() {}
}
